import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'
import { PortoutRequestForm } from '@/features/dashboard/portout-request/form/PortoutRequestForm';
import { PortoutRequestTypeEnum } from '@/features/dashboard/portout-request/portoutRequestEnum';

export const Route = createFileRoute('/_dashboard/portout-requests/cancel')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle("解約依頼");
  return <PortoutRequestForm requestType={PortoutRequestTypeEnum.Cancel} />
}
